jQuery(function () {
    // スライダー-重要なお知らせセクション
    (function () {
        $('.newsImportant').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            arrows: true
        });
    })();
    // スライダー-recommendセクション
    (function () {
        $('.recommend_area').slick({
            centerMode: true,
            centerPadding: '5%',
            slidesToShow: 4,  // 表示するスライドの枚数
            slidesToScroll: 1, // 1回でスクロールするスライドの数
            infinite: true,    // 無限ループ
            dots: true,        // ドットナビゲーションの表示
            arrows: true,      // 矢印の表示
            responsive: [
            {
                breakpoint: 768, // 768px以下の設定（一般的なタブレット〜スマホサイズ）
                settings: {
                    centerPadding: '10%',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
        });
    })();
    // タブ切り替え-rankingセクション
    (function () {
    $('#PageContainer .rankingWrap .tabBtn').on('click', function () {
            var $wrapper = $(this).closest('.rankingWrap');
            var tabTarget = $(this).attr('data-tab');
            
            $wrapper.find('.tabBtn').removeClass('active');
            $(this).addClass('active');
            
            $wrapper.find('.tabContent').removeClass('is-active');
            $wrapper.find('.' + tabTarget).addClass('is-active');
        });
    })();
});